import { render, staticRenderFns } from "./GoogleBusinessReplyReview.vue?vue&type=template&id=3fe20562&scoped=true"
import script from "./GoogleBusinessReplyReview.vue?vue&type=script&lang=js"
export * from "./GoogleBusinessReplyReview.vue?vue&type=script&lang=js"
import style0 from "./GoogleBusinessReplyReview.vue?vue&type=style&index=0&id=3fe20562&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fe20562",
  null
  
)

export default component.exports